<csx-normal-mode-ioh-filter
  [level]="level"
  (showFilterChange)="onShowFilterChanges($event)"
></csx-normal-mode-ioh-filter>
